<template>
  <v-main>
    <v-container fluid style="max-width: 400px;" class="pa-0 pt-0">
      <vue-headful title="Team-Mitglied" description="Aimz"/>
      <header1 class="mt-10">Team-Mitglied</header1>
      <p class="headline pl-5 mt-5">{{email}}</p>
<!--      <v-row class="ml-5 mt-5" style="min-height: 40px;" v-if="changed">-->
<!--        <v-btn dark @click="save">Speichern</v-btn>-->
<!--        <v-btn class="ml-3" @click="load">Abbrechen</v-btn>-->
<!--      </v-row>-->
      <v-progress-linear v-if="loading" class="mr-10" indeterminate></v-progress-linear>
      <v-alert type="error" v-if="error">{{ reason }}</v-alert>
      <v-col class="mx-2 mt-3">
        <p class="headline">
          Ziele ab {{CurrentAbDate}}
        </p>
        <div class="d-flex" v-for="(item,i) in items">
          <p v-if="isVisible(item.activity)">
            <v-icon class="mr-3">mdi-flag</v-icon>
            <span>{{item.activity.name}}</span>:
            <br>
            <v-btn class="ml-9" small @click.stop="onEdit(item)">
              {{item.value}}
            </v-btn>
            <span class="ml-1 grey--text"> {{item.activity.unit}} {{item.activity.freq || "mal pro Woche"}}</span>
          </p>
        </div>
      </v-col>
    </v-container>
    <v-dialog v-model="edit" width="400">
      <v-card>
        <v-card-title>Ziel ändern</v-card-title>
        <v-card-text>
          <v-text-field :label="edit_label" v-model="edit_value" @keyup="onEditKeyUp"></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="" text @click="edit=false">
            Abbrechen
          </v-btn>
          <v-btn color="primary" @click="onEditSave">
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-main>
</template>

<script>
import Vue from "vue";
import CenterContainer from "@/components/CenterContainer";
import Header1 from "@/components/Header1";
import Lib from "@/components/ActivityLibrary";
import UserLib from "@/components/UserLib";
import {ArrayX} from "@/reusable/array_extensions";
import Kinds from "@/components/Kinds";
import {Targets} from "@/components/Targets";
import ActivityLibrary from "@/components/ActivityLibrary";

//const SETTINGS_CONTEXT = "@team";

export default {
  name: 'TeamMember',
  components: {CenterContainer, Header1},
  data() {
    return {
      loading: false,
      reason: '',
      error: false,
      email: undefined,
      year: undefined,
      activities: [],
      targets: {},
      activityLookup: {},
      items: [], // [{activity, value}, ...] sorted by aname
      edit:false,
      edit_label:"activity",
      edit_value:0,
      edit_activity:undefined,
    }
  },
  mounted() {
    this.year=new Date(Date.now()).getFullYear();
    this.email = this.$route.params.email;
    if (this.email)
      this.load();
  },
  methods: {
    async load() {
      this.$app.setIntern();
      this.loading = true;
      // --> load activities
      var activities = await this.$backend.get_all_objects(Kinds.KIND_ACTIVITY) || [];
      activities = activities.filter(x=>!x.deleted);
      var targets=await this.$backend.get_object(Kinds.KIND_TARGETS, Targets.makeId(this.year, this.email));
      this.loading=false;
      console.log({activities, targets});
      this.activities=activities;
      this.activityLookup={};
      activities.forEach(a=>this.activityLookup[a.id]=a);
      this.targets=targets;
      this.items=[];
      var items=[]
      Object.entries(this.CurrentValues).forEach(pair=>{
        var aid=pair[0];
        var activity=this.activityLookup[aid];
        var value=pair[1];
        if (activity)
          items.push({activity, value})
      });
      this.items=new ArrayX(items).sortBy(x=>x.activity.name);
    },
    onLoadSuccess(data) {
      this.loading = false;
      console.log("data", data);
      // data ||= {};
      // if (!data.members || data.members.length==0 || !data.members[0] || !data.members[0].email)
      //   data.members= [{email:undefined}];
      // console.log("data1", data);
      // this.settings = data;
      // this.settings_edited = JSON.parse(JSON.stringify(data));
      // this.updateEmails();
      //
      // this.$nextTick(()=> this.changed=false);
    },
    onLoadError(reason) {
      this.loading = false;
      //this.settings = {members: [{email:undefined}]};
      this.error = true;
      this.reason = reason;
      // this.updateEmails();
      // this.$nextTick(()=> this.changed=false);
    },
    isVisible(activity) {
      if (activity.private)
        return false;
      if (activity.type === ActivityLibrary.TYPE_SUMME)
        return false;
      return true;
    },
    onEdit(item) {
      var activity = item.activity;
      var value = item.value;
      this.edit_activity=activity;
      this.edit_label=item.activity.name;
      this.edit_value=value;
      this.edit=true;
    },
    onEditKeyUp(event){
      if (event.keyCode===13)
        this.onEditSave();
      else if (event.keyCode===27)
        this.edit=false;
    },
    onEditSave() {
      this.edit=false;
      var item=this.items.filter(x=>x.activity===this.edit_activity)[0];
      var new_value=parseInt(this.edit_value);
      console.log("New value:", new_value);
      if (new_value===undefined || new_value===null || new_value<0 || isNaN(new_value)) {
        this.$events.$emit("error", "Nur Werte größergleich Null")
        return;
      }
      item.value=new_value;
      var values= this.CurrentValues;
      values[item.activity.id]=new_value;
      this.save();
    },
    save() {
      //this.loading = true;
      console.log("Saving", this.targets)
      this.$backend.set_object(Kinds.KIND_TARGETS, Targets.makeId(this.year, this.email), this.targets);
      //   onSuccess: this.onSaveSuccess,
      //   onError: this.onSaveError
      // });
      //this.load();
    },
    onSaveSuccess(data) {
      this.loading = false;
      this.settings = data;
      //this.settings_edited = JSON.parse(JSON.stringify(data));
    },
    onSaveError(reason) {
      this.loading = false;
      this.error = true;
      this.reason = reason;
      this.load();
    },
    // onInviteAgain(email) {
    //   this.$backend.invite(email );
    // },
    isMember(status) {
      return status==UserLib.MemberJoined;
    }
  },
  computed: {
    CurrentValues() {
      return new Targets(this.targets).getCurrentTargets();
      // var now=new Date(Date.now());
      // if (!this.targets || !this.targets.Dates)
      //   return undefined;
      // var pastValues=this.targets.Dates.filter(x=> new Date(x.Date) <= now);
      // //console.log({pastValues});
      // return pastValues[0];
    },
    CurrentAbDate() {
      var now=new Date(Date.now());
      var values= this.CurrentValues;
      //console.log({values});
      if (!values)
        return now.toISOString().substring(0,10);
      return values.Date;
    }
  },
  watch: {
    // settings_edited: {
    //   deep: true,
    //   handler(o, n) {
    //     this.updateEmails();
    //     this.changed = true;
    //   }
    // }
  }
}
</script>

<style>
.rb {
  border: red 1px solid;
}

.full_width {
  width: 100%;
}
</style>